<template>
  <div class="excel-load flex flex-column card-header-divider">
    <div
        v-if="!loadStarted"
        class="excel-load__label display--flex justify-content-center"
    >
      <div class="excel-load__block display--flex justify-content-center align-item-center">
        <div>Загрузите excel файл с KPI, подготовленный по образцу
          <a
              :href=exampleLink
              target="_blank"
          >(ссылка на образец)</a></div>
        <div>
          <button class="btn btn-accent" @click="showPopup = true;">Загрузить</button>
        </div>
        <reference-upload-exel-popup v-if="showPopup" @close="closePopup"/>
      </div>
    </div>

    <preloader v-if="loadStarted"/>
  </div>
</template>

<script>
import {ref} from "@vue/reactivity";
import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
import CustomFileLoader from "@/components/Forms/Fields/CustomFileLoader.vue";
import {useStore} from "vuex";
import {notify} from "@kyvg/vue3-notification";
import {useRouter} from "vue-router";
import Preloader from "@/components/Technical/Preloader.vue";
import {computed, watch} from "@vue/runtime-core";
import ReferenceUploadExelPopup from "@/components/Popups/ReferenceUploadExelPopup.vue";
import ReferencePopup from "@/components/Popups/ReferencePopup.vue";

export default {
  components: {ReferencePopup, CustomSelect2, CustomFileLoader, Preloader, ReferenceUploadExelPopup},
  name: "excel-load-row",
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  setup(props, context) {
    const store = useStore(),
        router = useRouter(),
        exampleLink = process.env.VUE_APP_BACK + "/storage/kpi_download_example.xlsx";
    const hideOptions = ref(true);
    let file = null;
    let loadStarted = ref(false);

    const showPopup = ref(false);

    const closePopup = () => {
      showPopup.value = false
    };

    const excelReferencesList = computed(
        () => store.state.references.excelReferencesList
    );

    const loadingAttempt = (files) => {
      file = files[0];
      if (!file) {
        notify({
          type: "warning",
          title: "Необходимо выбрать файл",
        });
        return;
      }
      loadStarted.value = true;
      store
          .dispatch("references/loadReferencesExcel", {
            file: file,
          }).then(() => {
            loadStarted.value = false;
          }).catch((error) => {
            loadStarted.value = false;
            notify({
              type: "error",
              title: error.response.data ? error.response.data.message : error,
            })
          })
    }
    watch(excelReferencesList, () => {
      router.push("/excel/references");
    })

    return {
      showPopup,
      hideOptions,
      loadingAttempt,
      loadStarted,
      exampleLink,
      closePopup
    };
  },
};
</script>

<style lang="scss" scoped>
.excel-load {
  &__block {
    width: 100%;
    padding: 15px;
    border: 2px solid #ebebeb;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    a {
      color: #2cc185;
    }

    a:hover {
      color: #31d090;
    }

    .btn-accent {
      margin-top: 10px;
    }
  }

  &__block:not(:last-child) {
    border-right: none;
  }

  &__label {
    width: 100%;
    margin-bottom: 20px;
    font-weight: 400;

  }

  @media (max-width: 1200px) {
    &__label {
      flex-direction: column;
      align-items: center;
    }
    &__block {
      width: 100%;
    }
    &__block:not(:last-child) {
      border-right: 2px solid #ebebeb;
      border-bottom: none;
    }
  }

  &__row {
    .form-group:first-child {
      min-width: 50%;
    }

    .form-group {
      max-width: 50%;
    }
  }

  // .excel-load__example

  &__example {
    a {
      color: var(--main-color);
      font-weight: 300;
      font-size: 16px;
      cursor: pointer;
      padding: 6px;

      &:hover {
        color: var(--hover-color);
        border-color: var(--hover-color);
      }
    }
  }

  @media (max-width: 1024px) {
    &__row {
      flex-direction: column;
      align-items: flex-start;

      .form-group,
      .form-group:first-child {
        min-width: 100%;
        margin-bottom: 20px;
      }

      .form-group:not(:first-child) {
        align-items: center;
      }
    }

    .form-group > div {
      padding: 0;
    }

    &__example {
      margin-top: 15px;
    }
  }
}
</style>
